export default "__VITE_ASSET__I_794V2G__"